export class ErrorView {
    public element: HTMLDivElement;

    private _counter: HTMLDivElement;
    private _list: HTMLDivElement;
    private _count: number = 0;

    constructor() {
        this.element = document.createElement("div");
        this.element.className = "e5-error-view";
        this.element.textContent = "!";

        var style = this.element.style;
        style.display = "none";
        style.position = "fixed";
        style.width = "40px";
        style.height = "40px";
        style.lineHeight = "40px";
        style.fontSize = "24px";
        style.textAlign = "center";
        style.zIndex = "8192";
        style.bottom = "50px";
        style.right = "50px";
        style.borderRadius = "50%";
        style.backgroundColor = "#FFF";
        style.color = "#000";
        style.boxShadow = "0 0 5px rgba(0, 0, 0, 0.5)";
        style.cursor = "pointer";
        style.fontFamily = "Arial";
        style.fontWeight = "800";


        this._counter = document.createElement("div");
        this._counter.className = "e5-error-view__counter";
        this.element.appendChild(this._counter);

        var style = this._counter.style;
        style.position = "absolute";
        style.backgroundColor = "#F00";
        style.color = "#FFF";
        style.fontSize = "12px";
        style.lineHeight = "1";
        style.padding = "2px 5px";
        style.borderRadius = "2px";
        style.top = "0";
        style.left = "30px";
        style.boxShadow = "0 0 5px rgba(0, 0, 0, 0.5)";
        style.fontFamily = "monospace";
        style.textShadow = "0 0 3px #000";

        this._list = document.createElement("div");
        this._list.className = "e5-error-view__list";

        var style = this._list.style;
        style.position = "fixed";
        style.top = "0";
        style.left = "0";
        style.width = "100%";
        style.height = "100%";
        style.backgroundColor = "#FFF";
        style.zIndex = "4096";
        style.paddingBottom = "60px";
        style.overflowY = "scroll";
        style.overflowX = "hidden";
        style.boxSizing = "border-box";
        style.userSelect = "all";

        if (!document.body) {
            document.addEventListener("DOMContentLoaded", () => {
                document.body.appendChild(this.element);
            });
        } else {
            document.body.appendChild(this.element);
        }

        this.element.addEventListener("click", (e) => {
            if (this._list.parentNode) {
                this._list.remove();
            } else {
                document.body.appendChild(this._list);
            }
        });

        window.addEventListener("error", (e) => {
            if(e.error){
                this.add(e.error, "window.onerror");
            }
        }, true);

        window.addEventListener('unhandledrejection', (e) => {
            this.add(e.reason, "window.onunhandledrejection");
        }, true);
    }

    public add(error: any, origin:string): void {
        if (!error) {
            console.log(error, origin);
            error = {message: "Unbekanter Fehler: " + origin};
        }
        this._count++;
        this.element.style.display = "block";

        this._counter.textContent = this._count + "";

        var errorMessage = "";
        if (error.stack) {
            errorMessage = error.stack;
        } else if (error.message) {
            errorMessage = error.message;
        } else {
            errorMessage = String(error);
        }

        var am = document.createElement("pre");
        am.textContent = errorMessage;
        this._list.appendChild(am);

        var style = am.style;
        style.padding = "20px";
        style.width = "100%";
        style.overflowX = "auto";
        style.boxSizing = "border-box";
        style.borderBottom = "1px solid #EEE";
    }
}